import useSWR from "swr";

const useSWRGlobalState = (key, initialData, revalidateOnMount = true) => {
  const { data, mutate } = useSWR(key, () => initialData, {
    revalidateOnMount,
  });

  const setValue = async (value) => {
    await mutate(value, false);
  };

  return [data ?? initialData, setValue];
};

export default useSWRGlobalState;
